import Vue from 'vue'
import Router from 'vue-router'
import iframe from 'bjxy-component/iframe'

import index from './main/index.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    meta: {level: 'a1', title: 'MGM返现', report: { eventName: 'kadaimgmfanxian_zhuceluodiye', disable: true }},
    component: index
  },
  {
    path: '/iframe',
    name: 'iframe',
    meta: {level: 'd9', title: ''},
    component: iframe,
    props: (route) => ({query: route.query})
  },
  {path: '/**', redirect: '/index.html'}
]

export default function(store) {
  Vue.use(Router)
  return new Router({
    routes
  })
}
